import listenToAppInstall from '../services/listen-to-app-install';
import listenToEditModeChange from '../services/listen-to-edit-mode-change';
import listenToHistoryStateChange from '../services/listen-to-history-state-change';
import listenToSettingsChange from '../services/listen-to-settings-change';
import listenToMemberDetailsUpdated from '../services/listen-to-member-details-updated';
import scrollOnHistoryChange from '../services/scroll-on-history-change';

const storeHooks = (store, history) => {
  listenToAppInstall(store);
  listenToEditModeChange(store);
  listenToSettingsChange(store);
  listenToHistoryStateChange(store, history);
  listenToMemberDetailsUpdated(store);
  scrollOnHistoryChange(store, history);
};

export default storeHooks;
